<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="new-list-item" (click)="onItemClick()" [class.selected]="isSelected">
  <div class="list-item-row" matTooltip="{{ item.name || item.title }}" [matTooltipShowDelay]="800">
    <div *ngIf="!template" class="list-item-content">
      <span class="item-title">{{ item.name || item.title }}</span>
    </div>
    <div *ngIf="template" class="list-item-content">
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ data: item }">
      </ng-container>
    </div>
  </div>
</div>
